import { Fetcher } from '@this/src/util';
import type { TripDuplication } from '../types/messages';

type CreateParams = {
  tripId: number;
  searchQueryId?: number;
  displayPath: string;
  tripDuplications: TripDuplication[];
};

export const createTripDuplicateLog = async ({
  tripId,
  searchQueryId,
  displayPath,
  tripDuplications
}: CreateParams): Promise<void> => {
  if (tripDuplications.length === 0) {
    return;
  }

  await Fetcher.post('/trip_duplicate_logs', {
    trip_id: tripId,
    search_query_id: searchQueryId,
    display_path: displayPath,
    trip_duplications: tripDuplications.map(d => ({
      trip_id: d.tripId,
      user_name: d.userName,
      element_types: d.elementTypes
    }))
  });
};
